import React from 'react';
import HrnbCard from '../../../components/controls/HrnbCard';
import BattlePairsList from '../../../components/battles/BattlePairsList';
import { UserContext } from '../../../context/UserContext';
import { useContext } from 'react';
import '../../../css/pages/BattlePairsTab.css';

/**
 * Вкладка "Пары участников" для страницы деталей баттла
 * Отображает пары для парных раундов (PAIR type)
 * 
 * @component
 * @param {Object} props
 * @param {string} props.battleId - UUID баттла
 * @param {Array} props.rounds - Список раундов
 * @param {boolean} props.isAdmin - Права администратора
 */
export default function BattlePairsTab({ battleId, rounds = [], isAdmin = false }) {
  const { currentUser } = useContext(UserContext);

  // Фильтруем только раунды типа PAIR
  const pairRounds = rounds.filter(round => round.type === 'PAIR');

  // Проверка прав
  const isOrganizer = currentUser && rounds.some(round => 
    round.organizers?.some(org => org.id === currentUser.id)
  );
  const hasAdminRights = isAdmin || isOrganizer;

  if (pairRounds.length === 0) {
    return (
      <div className="battle-pairs-tab">
        <HrnbCard title="Пары участников" className="battle-pairs-tab__card">
          <div className="battle-pairs-tab__empty">
            <span className="battle-pairs-tab__empty-icon">🎭</span>
            <h3>Нет парных раундов</h3>
            <p>
              В этом баттле нет раундов с парным форматом (PAIR).
              Пары участников отображаются только для парных раундов.
            </p>
          </div>
        </HrnbCard>
      </div>
    );
  }

  return (
    <div className="battle-pairs-tab">
      <div className="battle-pairs-tab__header">
        <h2 className="battle-pairs-tab__title">
          🎯 Пары участников
        </h2>
        <p className="battle-pairs-tab__description">
          {pairRounds.length} парн{pairRounds.length === 1 ? 'ый' : pairRounds.length < 5 ? 'ых' : 'ых'} раунд{pairRounds.length === 1 ? '' : 'а'}
        </p>
      </div>

      <div className="battle-pairs-tab__rounds">
        {pairRounds.map((round) => (
          <div key={round.id} className="battle-pairs-tab__round-section">
            <HrnbCard 
              title={`Раунд ${round.number}: ${round.title}`}
              className="battle-pairs-tab__round-card"
            >
              <div className="battle-pairs-tab__round-info">
                <span className="battle-pairs-tab__round-meta">
                  📅 {new Date(round.startTime).toLocaleDateString('ru-RU')}
                </span>
                <span className={`battle-pairs-tab__round-status battle-pairs-tab__round-status--${round.status.toLowerCase()}`}>
                  {round.status === 'PREPARATION' && '⏳ Подготовка'}
                  {round.status === 'RUNNING' && '🔥 Идёт'}
                  {round.status === 'ENDED' && '✅ Завершён'}
                </span>
              </div>

              <BattlePairsList
                battleId={battleId}
                roundId={round.id}
                isAdmin={hasAdminRights}
                onPairUpdate={(result) => {
                  console.log('[BattlePairsTab] Pair updated:', result);
                  // Можно добавить дополнительную логику обновления
                }}
              />
            </HrnbCard>
          </div>
        ))}
      </div>
    </div>
  );
}
